import React from 'react'

export const positions = [
  {
    title: 'Python, NodeJS Back-end',
    icon: 'fab fa-python',
    total: 3,
    requirements: [
      'Sinh viên năm cuối',
      'Có kiến thức tốt về Resful API',
      'Có kiến thức tốt lập trình NodeJS - Express hoặc bất kỳ Backend framework',
      'Có kiến thức tốt lập trình Python là điểm cộng',
      'Có kiến thức NLP là điểm cộng',
      'Đam mê lập trình',
      'Có khả năng tự học, nghiên cứu tốt',
      'Có khả năng làm việc nhóm tốt '
    ]
  },
  {
    title: 'ReactJS Front-end',
    icon: 'fab fa-react',
    total: 3,
    requirements: [
      'Sinh viên năm cuối',
      'Có kiến thức tốt lập trình ReactJS hoặc bất kỳ Frontend Framework',
      'Có kiến thức HTML/CSS',
      'Có kiến thức UI/UX Design là điểm cộng',
      'Đam mê lập trình',
      'Có khả năng tự học, nghiên cứu tốt',
      'Có khả năng làm việc nhóm tốt'
    ]
  },
  {
    title: 'Brand Marketing',
    icon: 'fas fa-bullhorn',
    total: 1,
    requirements: [
      'Sinh viên năm cuối (năm 3 hoặc năm 4)',
      'Dự định phát triển trong mảng Social Marketing',
      'Đam mê trong lĩnh vực Brand Marketing',
      'Khả năng viết tốt',
      'Kỹ năng giao tiếp và ứng xử tốt',
      'Năng động, học hỏi nhanh',
      'Kỹ năng làm việc nhóm tốt'
    ]
  },
  {
    title: 'Data Analysis',
    icon: 'fas fa-chart-area',
    total: 1,
    requirements: [
      'Sinh viên năm cuối (năm 3 hoặc năm 4)',
      'Có đam mê ở mảng Data Science & Business Intelligence',
      'Kỹ năng phân tích tốt',
      'Năng động, học hỏi nhanh',
      'Kỹ năng giao tiếp tốt'
    ]
  },
  {
    title: 'Content Manager',
    icon: 'fas fa-pen',
    total: 1,
    requirements: [
      'Sinh viên năm cuối (năm 3 hoặc năm 4)',
      'Có kiến thức về các bài test chuẩn bị cho các kỳ thi chuẩn hóa (phổ thông quốc gia, Tiếng Anh như IELTS, TOEIC, TOEFL, SAT,…)',
      'Có đam mê trong việc phát triển và quản lý nội dung các đề thi',
      'Kỹ năng giao tiếp và ứng xử tốt',
      'Kỹ năng quản lý thời gian tốt'
    ]
  }
]

export const mentors = [
  {
    avatar: '/img/internship/mentors/thanhtung.png',
    fullName: 'Phan Thanh Tùng',
    position: 'CEO tungtung.vn'
  }, {
    avatar: '/img/internship/mentors/duchuy.png',
    fullName: 'Lê Đức Huy',
    position: 'CEO Green Studio'
  }, {
    avatar: '/img/internship/mentors/toantien.png',
    fullName: 'Nguyễn Toàn Tiến',
    position: 'CTO Tungtung.vn'
  }, {
    avatar: '/img/internship/mentors/quangduy.png',
    fullName: 'Võ Quang Duy',
    position: 'COO Tungtung.vn'
  }, {
    avatar: '/img/internship/mentors/thanhthao.png',
    fullName: 'Trần Thanh Thảo',
    position: <span>Senior Designer<br />Tungtung.vn</span>
  }, {
    avatar: '/img/internship/mentors/nguyentrong.png',
    fullName: 'Trần Nguyên Trọng',
    position: <span>Technical Product Owner<br />Tungtung.vn</span>
  }
]
